export function StartJobsForDateCtrl ($uibModalInstance, $scope, $state, $uibModal, $filter, $translate, workshopAPI, sessionObjAPI, messages, confirm) {

  $scope.start_date = '';
  $scope.dateFormat  = sessionObjAPI.company().country_code == 'usa' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.startJobsForDate = function () {
    var date = $filter('date')(new Date($scope.start_date), $scope.dateFormat)
    var date_for_jobs = $filter('date')(new Date($scope.start_date), 'yyyy-MM-dd')
    confirm.generic($translate.instant('BOOKING_SPACE.BOOKINGS_FOR_DATE', {date: date})).then(function () {
      $uibModalInstance.dismiss();
      return workshopAPI.get('/events/get_events_for_today', date_for_jobs)
    }).then(function (data) {
      messages.show($translate.instant('BOOKING_SPACE.INVOICES_CREATED_FOR_DATE', {date: date}), 'success');
    }, function (err) {
      messages.error(err);
    });
  };
}